import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CollectionApiClient, IPaginationParameters, IPaginationResponse } from '../../../common';
import {
  ICreateVehicleRequest,
  IUpdateVehicleRequest,
  IVehicleLookupsResponse,
  IVehicleResponse,
  IVehiclesBasePaginationParameters
} from '../dtos';
import { ICheckVehicleExistenceRequest } from '../dtos/requests/check-vehicle-existence.request';
import { IVehicleExistenceResponse } from '../dtos/responses/vehicle-existence.response';
import { IVehiclesApiClient } from './i-vehicles-api.client';
import { VehicleManagementCollections } from '../../common/collections';

@Injectable({
  providedIn: 'root'
})
export class VehiclesApiClient implements IVehiclesApiClient {
  public collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(VehicleManagementCollections.vehicles, http);
  }

  getCollectionApiClient(): CollectionApiClient {
    return this.collectionApiClient;
  }

  getById(id: string): Observable<IVehicleResponse> {
    return this.collectionApiClient.get({
      id
    });
  }

  lookups(paginationParameters?: IPaginationParameters): Observable<IVehicleLookupsResponse> {
    const params = {
      collectionName: VehicleManagementCollections.vehicleBodyTypes(),
      ...(paginationParameters && { paginationParameters })
    };
    return this.collectionApiClient.get(params);
  }

  lookupsPublic(paginationParameters?: IPaginationParameters): Observable<IVehicleLookupsResponse> {
    const params = {
      collectionName: VehicleManagementCollections.vehicleBodyTypesPublic(),
      ...(paginationParameters && { paginationParameters })
    };
    return this.collectionApiClient.get(params);
  }

  update(id: string, request: IUpdateVehicleRequest): Observable<void> {
    return this.collectionApiClient.put({
      id,
      body: request
    });
  }

  getMyVehicles(
    paginationParameters?: IVehiclesBasePaginationParameters
  ): Observable<IPaginationResponse<IVehicleResponse>> {
    return this.collectionApiClient.get({
      collectionName: 'customer-management/customer-profiles/my/vehicles',
      paginationParameters
    });
  }

  getMyVehicleById(id: string): Observable<IVehicleResponse> {
    return this.collectionApiClient.get({
      collectionName: `customer-management/customer-profiles/my/vehicles/${id}`
    });
  }

  createMyVehicle(request: ICreateVehicleRequest): Observable<IVehicleResponse> {
    return this.collectionApiClient.post({
      collectionName: 'customer-management/customer-profiles/my/vehicles',
      body: request
    });
  }

  updateMyVehicle(id: string, request: IUpdateVehicleRequest): Observable<void> {
    return this.collectionApiClient.put({
      collectionName: `customer-management/customer-profiles/my/vehicles/${id}`,
      body: request
    });
  }

  getPublicVehicles(
    paginationParameters?: IVehiclesBasePaginationParameters
  ): Observable<IPaginationResponse<IVehicleResponse>> {
    return this.collectionApiClient.get({
      collectionName: VehicleManagementCollections.publicVehicles,
      paginationParameters
    });
  }

  checkExistence(request: ICheckVehicleExistenceRequest): Observable<IVehicleExistenceResponse> {
    return this.collectionApiClient.get({
      collectionName: VehicleManagementCollections.vehicleExistence,
      paginationParameters: {
        vehicleType: request.vehicleType,
        countryId: request.countryId,
        plateLetters: request.plateLetters,
        plateDigits: request.plateDigits,
        plateLicenseTypeId: request.plateLicenseTypeId
      } as any
    });
  }
}
